import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

// Plain-CSS bar strip bound to a real series. Design stage may swap the renderer, not the binding.
export function SeriesBars({ testId, title, subtitle, points, valueKey, labelFor, emptyText, tone = "orange", headline }) {
  const max = Math.max(1, ...points.map((p) => p[valueKey]));
  const total = points.reduce((n, p) => n + p[valueKey], 0);
  return (
    <Card data-testid={testId} className="border-jigsaw-border">
      <CardHeader className="pb-2">
        <CardTitle className="text-base text-jigsaw-navy">{title}</CardTitle>
        {headline != null && <p data-testid={`${testId}-headline`} className="mt-1 text-[32px] font-bold leading-none tracking-[-0.02em] text-jigsaw-navy">{headline}<span className="ml-2 text-sm font-medium text-jigsaw-muted">nights in total</span></p>}
        {subtitle && <p className="text-xs text-jigsaw-muted">{subtitle}</p>}
      </CardHeader>
      <CardContent>
        {total === 0 ? (
          <p data-testid={`${testId}-empty`} className="text-sm text-jigsaw-muted">{emptyText}</p>
        ) : (
          <div className="flex h-28 items-end gap-1" role="img" aria-label={title}>
            {points.map((p) => (
              <div key={p.date || p.month} className="group relative flex h-full flex-1 flex-col items-center justify-end" title={`${labelFor(p)}: ${p[valueKey]}`}>
                <div className={`w-full rounded-t-sm transition-[height] ${tone === "blue" ? "bg-[#3157A4]/80 group-hover:bg-[#3157A4]" : "bg-jigsaw-orange/80 group-hover:bg-jigsaw-orange"}`} style={{ height: `${Math.max(2, (p[valueKey] / max) * 100)}%` }} />
              </div>
            ))}
          </div>
        )}
        {total > 0 && (
          <div className="mt-1 flex justify-between text-[10px] text-jigsaw-muted">
            <span>{labelFor(points[0])}</span><span>{labelFor(points[points.length - 1])}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
